import { days } from "./days";
import { titles } from "./titles";
import { genders } from "./genders";
import { pageLinks } from "./pageLinks";
import { audiences } from "./audiences";
import { languages } from "./languages";
import { userTypes } from "./userTypes";
import { countries } from "./countries";
import { intervals } from "./intervals";
import { currencies } from "./currencies";
import { sortOrders } from "./sortOrders";
import { answerTypes } from "./answerTypes";
import { courseTypes } from "./courseTypes";
import { ethnicities } from "./ethnicities";
import { difficulties } from "./difficulties";
import { otpDurations } from "./otpDurations";
import { sectionTypes } from "./sectionTypes";
import { relationships } from "./relationship";
import { nationalities } from "./nationalities";
import { connectionLinks } from "./connectionLinks";
import { academicFeatures } from "./academicFeatures";
import { parentalFeatures } from "./parentalFeatures";
import { organizationTypes } from "./organizationTypes";
import { reoccurrenceTypes } from "./reoccurrenceTypes";
import { applicationStatuses } from "./applicationStatuses";

export const PRIMARY_COLOR = "hsl(112.94, 52.15%, 31.96%)";
export const SECONDARY_COLOR = "hsl(193.61, 95.2%, 24.51%)";
export const SUCCESS_COLOR = "hsl(146, 79%, 44%)";
export const WARNING_COLOR = "hsl(37, 91%, 55%)";
export const DESTRUCTIVE_COLOR = "hsl(339, 90%, 51%)";

export const SPOUSEUUID = "9d62f623-b106-4036-abb2-0ca55016f464";

export const APP_NAME = "Cognition";
export const APP_DESCRIPTION = "Cognition is an intuitive learning management system designed to enhance the educational experience. With user-friendly features, customizable courses, and robust analytics, Cognition empowers educators and learners to connect, engage, and succeed in their learning journeys.";

export const ADMIN_ORG_NAME: string = "Baseel Partners LLP";
export const ADMIN_ORG_TAX_NO: string = "#123456789";
export const CONTACT_EMAIL: string = "contactus@baseel.in";
export const CONTACT_NO: string = "+44 7825362359";
export const CONTACT_ADDRESS: string = "167 Great Portland St.";
export const CONTACT_CITY: string = "London";
export const CONTACT_PROVINCE: string = "England";
export const CONTACT_COUNTRY: string = "United Kingdom";
export const CONTACT_ZIP_CODE: string = "W1W 5PF";

export const DEFAULT_SCHOOL_UNIVERSITY_UUID = "2117f076-0f3e-4792-891b-7bd86ca23b5e";

export {
	academicFeatures,
	answerTypes,
	applicationStatuses,
	audiences,
	connectionLinks,
	countries,
	courseTypes,
	currencies,
	days,
	difficulties,
	ethnicities,
	genders,
	intervals,
	languages,
	nationalities,
	organizationTypes,
	otpDurations,
	pageLinks,
	parentalFeatures,
	relationships,
	reoccurrenceTypes,
	sectionTypes,
	sortOrders,
	titles,
	userTypes,
};
